import { render, staticRenderFns } from "./RemoveForm.modal.vue?vue&type=template&id=e3a861b0&scoped=true&"
import script from "./RemoveForm.modal.vue?vue&type=script&lang=ts&"
export * from "./RemoveForm.modal.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveForm.modal.vue?vue&type=style&index=0&id=e3a861b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a861b0",
  null
  
)

export default component.exports